import { useApi } from './useApi';
import { url } from '../../utils/confserveur';
// `enabled` (facultatif, 2026-09-29) : 'not-enabled' n'appelle pas le serveur.
// Sert au menu d'attendu qui ne charge l'arbre d'un AUTRE niveau que lorsque
// le prof le choisit ; les appels à un seul argument ne changent pas.
export const useTheme = (niveau, enabled) => {
  const urlfetch =  niveau ? `${url}themes/?niveau=${niveau}` : url+'themes/';

  return useApi(urlfetch, [], undefined, enabled);
};
